document.addEventListener('DOMContentLoaded', initTrackOrderFormHandler);

function getStatusFromChangeDates(statusChangeDates) {
    if (!statusChangeDates) {
        return '';
    }
    
    const statusPriority = ['90', '80', '70', '60', '20', '1', '95', '96', '97', '98'];
    
    for (const statusCode of statusPriority) {
        if (statusChangeDates[statusCode]) {
            return statusCode;
        }
    }
    
    return '';
}

function initTrackOrderFormHandler() {
    const trackOrderForm = document.getElementById('track-order-form');
    const errorMessage = document.getElementById('track-order-error-message');
    const errorText = errorMessage?.querySelector('p.note.form-error');
    const submitButton = document.getElementById('track-order-submit-button');
    const pizzabarContainer = document.getElementById('track-order-pizzabar-container');
    const orderTableContainer = document.getElementById('track-order-table-container');

    trackOrderForm?.addEventListener('submit', async (event) => {
        event.preventDefault();
        submitButton.disabled = true;
        
        errorMessage?.classList.add('hide-down');
        pizzabarContainer?.classList.add('hide-down');
        orderTableContainer?.classList.add('hide-down');
        
        const formData = new FormData(trackOrderForm);
        const orderEmail = formData.get("email");
        const orderName = formData.get("order_number");

        try {
            const body = {
                orderName: orderName,
                orderEmail: orderEmail
            };
            
            const response = await fetch('/apps/api/orders/status/details', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(body),
            });

            if (!response.ok) {
                throw new Error('שגיאה בטעינת פרטי ההזמנה. אנא בדוק את הפרטים שהזנת ונסה שוב.');
            }

            const contentType = response.headers.get('content-type');
            if (!contentType || !contentType.includes('application/json')) {
                throw new Error('שגיאה בטעינת פרטי ההזמנה. אנא בדוק את הפרטים שהזנת ונסה שוב.');
            }

            const responseJson = await response.json();
            
            if (!responseJson.success) {
                throw new Error(responseJson.message || 'שגיאה בטעינת פרטי ההזמנה. אנא בדוק את הפרטים שהזנת ונסה שוב.');
            }
            
            if (!responseJson.statusChangeDates){
                throw new Error('הזמנה לא נמצאה. אנא בדוק את כתובת המייל ומספר ההזמנה שהזנת.');
            }

            const pizzabarWrapper = document.getElementById('track-order-pizzabar-wrapper');
            const orderTableWrapper = document.getElementById('track-order-table-wrapper');
            
            if (pizzabarWrapper) {
                pizzabarWrapper.innerHTML = '';
            }
            if (orderTableWrapper) {
                orderTableWrapper.innerHTML = '';
            }
            
                const orderTableTemplate = document.getElementById('order-table-template');
                const orderTableClone = orderTableTemplate.content.cloneNode(true);
                const orderRow = orderTableClone.querySelector('.boa-order-row');
                
                if (!orderRow) {
                    return;
                }
                    const orderNameCell = orderRow.querySelector('.boa-row-name');
                    const orderDateCell = orderRow.querySelector('.boa-row-date');
                    const orderCountCell = orderRow.querySelector('.boa-row-count');
                    const orderTotalCell = orderRow.querySelector('.boa-row-total');
                    const orderStatusCell = orderRow.querySelector('.boa-row-status');
                    
                    if (!orderNameCell || !orderDateCell || !orderCountCell || !orderTotalCell || !orderStatusCell) {
                        return;
                    }
                        orderNameCell.textContent = orderName;
                    
                    
                    if (orderDateCell && responseJson.orderDate) {
                        const date = new Date(responseJson.orderDate);
                        const formattedDate = date.toLocaleDateString('he-IL', {
                            day: '2-digit',
                            month: '2-digit',
                            year: 'numeric'
                        });
                        orderDateCell.textContent = formattedDate;
                    }
                    
                    orderCountCell.textContent = responseJson.totalItemCount?.toString() || '0';
                    
                    
                    if (responseJson.totalAmount !== undefined) {
                        const freeText = 'חינם';
                        const totalAmount = parseFloat(responseJson.totalAmount);
                        const formattedTotal = totalAmount === 0 
                            ? freeText
                            : `₪ ${totalAmount.toFixed(2)}`;
                        orderTotalCell.textContent = formattedTotal;
                    }
                    
                        const inProcessText = 'בתהליך עיבוד';
                        let statusValue = '';
                        let statusText = '';
                        
                        if (responseJson.status) {
                            statusValue = responseJson.status.toString();
                        } else {
                            statusValue = getStatusFromChangeDates(responseJson.statusChangeDates);
                        }
                        
                        if (!statusValue) {
                            return;
                        }
                            const statusTranslations = {
                                '1': 'פתוח',
                                '2': '',
                                '3': '',
                                '20': 'בליקוט',
                                '60': 'נסגר חלקי',
                                '61': 'ליקוט חלקי',
                                '62': 'ממשיך לאריזה',
                                '70': 'נארזה למשלוח',
                                '80': 'נמסרה למשלח',
                                '81': '',
                                '90': 'נמסרה ללקוח',
                                '95': 'בקשה לביטול',
                                '96': 'בוטל - אין במלאי',
                                '97': 'בוטל - לקוח',
                                '98': 'לא ניתן לבטל'
                            };
                            statusText = statusTranslations[statusValue] || '';
                        
                        
                        orderStatusCell.textContent = statusText || inProcessText;
                    
                    
                    orderTableWrapper.appendChild(orderTableClone);
                    orderTableContainer?.classList.remove('hide-down');
            
            // Skip pizzabar building for cancelled orders
            const cancelledStatuses = ['96', '97'];
            if (cancelledStatuses.includes(statusValue)) {
                return;
            }

            const pizzabarTemplate = document.getElementById('pizzabar-template');
            if (!pizzabarWrapper || !pizzabarTemplate) {
                throw new Error('Missing required DOM elements');
            }

            const translations = {
                1: 'ההזמנה התקבלה! אנחנו על זה...',
                2: 'הזמנתך נארזה. תתחילו להתלהב :)',
                3: 'עכשיו זה רשמי! המשלוח בדרך אליך',
                4: 'החבילה הגיעה. מתרגשים יחד איתך!'
            };
            
            const pizzabarClone = pizzabarTemplate.content.cloneNode(true);
            const pizzabar = pizzabarClone.querySelector('.pizzabar');
            
            if (!pizzabar) {
                throw new Error('Template structure error');
            }

            const orderStatuses = {
              '1': 1,
              '2': 1,
              '3': 1,
              '20': 1,
              '60': 2,
              '61': 2,
              '62': 2,
              '70': 2,
              '80': 3,
              '81': 3,
              '90': 4,
            };
            
            let current = 1;
            if (orderStatuses[responseJson.status]) {
                current = orderStatuses[responseJson.status];
            }
            pizzabar.setAttribute('data-current', current);
            
            const stepTitles = pizzabar.querySelectorAll('.step-title');
            const stepDates = pizzabar.querySelectorAll('.step-date');
            
            if (stepTitles.length >= 4 && stepDates.length >= 4) {
                stepTitles[0].textContent = translations[1];
                stepDates[0].textContent = responseJson.statusChangeDates['1'];
                
                stepTitles[1].textContent = translations[2];
                stepDates[1].textContent = responseJson.statusChangeDates['20'];
                
                stepTitles[2].textContent = translations[3];
                stepDates[2].textContent = responseJson.statusChangeDates['80'];
                
                stepTitles[3].textContent = translations[4];
                stepDates[3].textContent = responseJson.statusChangeDates['90'];
            }
            
            pizzabarWrapper.appendChild(pizzabar);
            pizzabarContainer?.classList.remove('hide-down');
        } catch (error) {
            let errorMessageText = 'שגיאה בטעינת פרטי ההזמנה. אנא בדוק את הפרטים שהזנת ונסה שוב.';
            
            if (error.message && error.message !== 'שגיאה בטעינת פרטי ההזמנה. אנא בדוק את הפרטים שהזנת ונסה שוב.' && error.message !== 'הזמנה לא נמצאה. אנא בדוק את כתובת המייל ומספר ההזמנה שהזנת.') {
                errorMessageText = error.message;
            }
            
            if (errorText) {
                errorText.textContent = errorMessageText;
            }
            errorMessage?.classList.remove('hide-down');

        } finally {
            submitButton.disabled = false;
        }
    });
}
